module.exports = __webpack_public_path__ + "./assets/img/team_2.84559599.png";